import { decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives } from "../decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsBaseCreativeRename =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id/rename";

export const decisioningStudioAgentsBaseCreativeRenameCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
];
